"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toPathString = exports.setSearchParams = exports.setOAuthToObject = exports.setBearerAuthToObject = exports.setBasicAuthToObject = exports.setApiKeyToObject = exports.serializeDataIfNeeded = exports.createRequestFunction = exports.assertParamExists = exports.DUMMY_BASE_URL = void 0;
var _base = require("./base");
const DUMMY_BASE_URL = exports.DUMMY_BASE_URL = 'https://example.com';
const assertParamExists = function (functionName, paramName, paramValue) {
  if (paramValue === null || paramValue === undefined) {
    throw new _base.RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
  }
};
exports.assertParamExists = assertParamExists;
const setApiKeyToObject = async function (object, keyParamName, configuration) {
  if (configuration && configuration.apiKey) {
    const localVarApiKeyValue = typeof configuration.apiKey === 'function' ? await configuration.apiKey(keyParamName) : await configuration.apiKey;
    object[keyParamName] = localVarApiKeyValue;
  }
};
exports.setApiKeyToObject = setApiKeyToObject;
const setBasicAuthToObject = function (object, configuration) {
  if (configuration && (configuration.username || configuration.password)) {
    object["auth"] = {
      username: configuration.username,
      password: configuration.password
    };
  }
};
exports.setBasicAuthToObject = setBasicAuthToObject;
const setBearerAuthToObject = async function (object, configuration) {
  if (configuration && configuration.accessToken) {
    const accessToken = typeof configuration.accessToken === 'function' ? await configuration.accessToken() : await configuration.accessToken;
    object["Authorization"] = "Bearer " + accessToken;
  }
};
exports.setBearerAuthToObject = setBearerAuthToObject;
const setOAuthToObject = async function (object, name, scopes, configuration) {
  if (configuration && configuration.accessToken) {
    const localVarAccessTokenValue = typeof configuration.accessToken === 'function' ? await configuration.accessToken(name, scopes) : await configuration.accessToken;
    object["Authorization"] = "Bearer " + localVarAccessTokenValue;
  }
};
exports.setOAuthToObject = setOAuthToObject;
const setSearchParams = function (url, ...objects) {
  const searchParams = new URLSearchParams(url.search);
  for (const object of objects) {
    for (const key in object) {
      if (Array.isArray(object[key])) {
        searchParams.delete(key);
        for (const item of object[key]) {
          searchParams.append(key, item);
        }
      } else {
        searchParams.set(key, object[key]);
      }
    }
  }
  url.search = searchParams.toString();
};
exports.setSearchParams = setSearchParams;
const serializeDataIfNeeded = function (value, requestOptions, configuration) {
  const nonString = typeof value !== 'string';
  const needsSerialization = nonString && configuration && configuration.isJsonMime ? configuration.isJsonMime(requestOptions.headers['Content-Type']) : nonString;
  return needsSerialization ? JSON.stringify(value !== undefined ? value : {}) : value || "";
};
exports.serializeDataIfNeeded = serializeDataIfNeeded;
const toPathString = function (url) {
  return url.pathname + url.search + url.hash;
};
exports.toPathString = toPathString;
const createRequestFunction = function (axiosArgs, globalAxios, BASE_PATH, configuration) {
  return (axios = globalAxios, basePath = BASE_PATH) => {
    const axiosRequestArgs = {
      ...axiosArgs.options,
      url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + axiosArgs.url
    };
    return axios.request(axiosRequestArgs);
  };
};
exports.createRequestFunction = createRequestFunction;
//# sourceMappingURL=common.js.map